// This file was auto-generated by Fern from our API Definition.
export const ComparisonOperator = {
    Is: "is",
    IsNot: "is_not",
};
